import React, { useState } from 'react';
import { LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Button from './ui/Button';

const LogoutButton = ({ 
  className = '',
  variant = 'outline',
  size = 'sm',
  showLabel = true,
  label = 'Logout',
  ariaLabel = 'Sign out of your account'
}) => {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const [loggingOut, setLoggingOut] = useState(false);

  const handleLogout = async () => {
    if (loggingOut) return;
    
    setLoggingOut(true);
    try {
      const { error } = await signOut();
      if (!error) {
        navigate('/sign-in');
      } else {
        console.error('Logout error:', error);
      }
    } catch (error) {
      console.error('Logout failed:', error);
    } finally {
      setLoggingOut(false);
    }
  };

  return (
    <Button
      onClick={handleLogout}
      variant={variant}
      size={size}
      disabled={loggingOut}
      className={`flex items-center justify-center gap-2 min-w-[44px] min-h-[44px] touch-manipulation active:scale-95 transition-transform relative z-[60] bg-red-50 hover:bg-red-100 border-2 border-red-300 hover:border-red-400 text-red-700 hover:text-red-800 shadow-md ${className}`}
      aria-label={ariaLabel}
    >
      <LogOut className="w-5 h-5" strokeWidth={2.5} />
      {showLabel && <span className="font-medium">{loggingOut ? 'Signing out...' : label}</span>}
    </Button>
  );
};

export default LogoutButton;